<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('military_information') }}</h5>
        <div class="border rounded p-4 mb-4">
            <b-row>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('military_status') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'military_status_name') }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4" v-if="studentProgram.military_status=='delayed'">
                    <div class="label-as-input-div">
                        <label>{{ $t('military_delay_date') }}</label>
                        <div>
                            {{ studentProgram.military_delay_date ? this.toLocaleDate(studentProgram.military_delay_date) : '-' }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('military_service_city') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'military_service_city_code') }}
                            <span> / </span>
                            {{ getObjectValue(studentProgram, 'military_service_city_name') }}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_updatemilitary') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_updatemilitary') && editMode">
            >
            <template v-slot:CommonModalTitle>
                {{changeText($t('edit')) }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

